import { Merchant } from '@nemuru-eng/js-api-client';
import { useEffect, useState } from 'react';

import { useUser } from '@/hooks/useUser';

export const useMerchantGroupMerchants = () => {
  const { userEntity, isUserMerchantGroup } = useUser();

  const [merchants, setMerchants] = useState<Merchant[] | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!isUserMerchantGroup || !userEntity) return;

    let cancelled = false;
    setLoading(true);
    userEntity
      .getMerchantGroupMerchants()
      .then((result) => {
        if (cancelled) return;
        setMerchants(result ?? []);
      })
      .finally(() => {
        if (cancelled) return;
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [userEntity, isUserMerchantGroup]);

  return { merchants, loading };
};
